module.exports = __webpack_public_path__ + "static/media/select.e2029d48.svg";